<!-- eslint-disable vue/max-len -->
<template>
  <svg
    :class="`color-fill-${color}`"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 21V3H13.6L14.0267 5.11765H20V15.7059H12.5333L12.1067 13.5882H6.13333V21H4ZM14.2933 13.5882H17.8667V7.23529H12.2667L11.84 5.11765H6.13333V11.4706H13.8667L14.2933 13.5882Z"
    />
  </svg>
</template>

<script setup lang="ts">
interface icon {
  color?: string;
}

withDefaults(defineProps<icon>(), {
  color: 'black',
});
</script>
